<div fxLayout="column" [ngStyle]="{'height.px': innerHeight}" class="no_userselect">

  <!-- title -->
  <span class="titlefid_point">{{"use_fidelity_points_pop"|translate}} </span>
  <div fxLayoutAlign="center center" class="padTB10 texts"> <span class="fid_point rounded-button">{{clientFidelity}}
     {{"loyalty_points"|translate| uppercase}} </span></div>


  <!-- Content -->
  <div class=" scrolled heig ">
    <ng-container *ngFor="let item of fidelityProducts ;let i = index;let first = first;" >
      <!-- && item.fidelity_points<=clientFidelityfirst -->
      <div fxLayout="row" class=" full-w divider" *ngIf="item.fidelity_points " [class.divider-top]="first" fxLayoutGap="10px" style="padding:10px;">
        <!-- image -->
        <img *ngIf="item.image.length > 0" src="{{item.image[0] | prodSizeFilter:72}}" class="basket-prod-img ">
        <img *ngIf="item.image.length < 1" src="/assets/img/not-found.png" class="basket-prod-img ">

        <!-- infos -->
        <div fxLayout="column" fxLayoutAlign="center start ">
          <div class="texts">{{item.name | capitalize}}</div>
          <div class="textxxs">{{item.fidelity_points }}  {{"loyalty_points"|translate| lowercase}}</div>


        <!-- details -->
        <div *ngIf="item.details.length > 0" fxLayout="column">
          <div *ngFor="let sdet of item.details" style="line-height: 5px; padding-left: 10px" fxLayout="column">


            <div fxLayout="row" fxLayoutAlign="space-between center" class="full-w">
              <div>
                <span class="mat-caption" style="font-size: x-small" *ngIf="sdet.quantity > 1">{{ sdet.quantity
                  }}&nbsp;&nbsp;</span>
                <span class="mat-caption boldest" style="font-size: x-small">{{ sdet.name | capitalize }}</span>
              </div>

            </div>

           <div *ngFor="let ssdet of sdet.details" style="padding-left: 10px">
              <div fxLayout="row" fxLayoutAlign="space-between center" class="full-w">
                <div>
                  <span class="mat-caption" style="font-size: xx-small" *ngIf="sdet.quantity > 1">{{ ssdet.quantity
                    }}&nbsp;&nbsp;</span>
                  <span class="mat-caption" style="font-size: xx-small">{{
                    ssdet.name | capitalize
                    }}</span>
                </div>

              </div>
            </div>


          </div>

          </div>
        </div>



        <div fxFlex fxLayoutAlign="end center">

          <button mat-stroked-button class="great-ico b"   (click)="selecProductFid(item)" *ngIf="!item.selected &&item.fidelity_points<=clientFidelity">
            <span class="textxs">{{'offer_loyalty_points_button'|translate}}</span>
          </button>



          <button mat-stroked-button class="great b" [disabled]="false" (click)="selecProductFid(item)" *ngIf="item.selected">
            <span class="textxs">{{'free_loyalty_points_button'|translate}}</span>
          </button>

        </div>


      </div>


    </ng-container>

  </div>

  <!--  btn bottom -->
  <div class="layout-padd positionBottom" fxLayoutGap="10px" fxflex>

    <button mat-stroked-button class="dark-ico rounded-button" fxFlex (click)="closeDial()" angulartics2On="click"
      angularticsAction="closeFidelityDial" angularticsCategory="FidelityDial">
      <span class="mat-title">{{ "cancel_button"|translate}}</span>
    </button>


    <button mat-stroked-button class="primary rounded-button" fxFlex (click)="validDial()" angulartics2On="click"
      angularticsAction="validFidelityDial" angularticsCategory="validFidelityDial">
      <span class="mat-title">{{"validate-button"|translate}}</span>
    </button>

  </div>

</div>
